import { ClickableGraphArea, Marker } from '@mi-front/ui';

/** Playhead color matching logger Playhead (theme.green). */
const PLAYHEAD_COLOR = '#08ecb8';

export interface RangeWaveformPlayerMarkersProps {
  from: number;
  to: number;
  currentTs: number | null;
  onSeek: (ts: number) => void;
  tz?: string;
}

/**
 * Click-to-seek overlay, hover timestamp label, and compact playhead for a range waveform stream.
 */
export function RangeWaveformPlayerMarkers({
  from,
  to,
  currentTs,
  onSeek,
  tz,
}: RangeWaveformPlayerMarkersProps) {
  const playheadInRange = currentTs != null && currentTs >= from && currentTs <= to;

  return (
    <>
      <ClickableGraphArea
        onTsClick={onSeek}
        showHoverCursor
        showHoverTimeLabel
        hoverTimeLabelSize="sm"
        tz={tz}
      />
      {playheadInRange && <Marker className="el-playhead" color={PLAYHEAD_COLOR} ts={currentTs} />}
    </>
  );
}
